import { render, staticRenderFns } from "./environmentalReportProofStatus.vue?vue&type=template&id=f2d4023a&scoped=true"
import script from "./environmentalReportProofStatus.vue?vue&type=script&lang=js"
export * from "./environmentalReportProofStatus.vue?vue&type=script&lang=js"
import style0 from "./environmentalReportProofStatus.vue?vue&type=style&index=0&id=f2d4023a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2d4023a",
  null
  
)

export default component.exports